import React, { useEffect, useState } from 'react';
import PageContainer from '../components/containers/PageContainer';
import CustomTable from '../components/ui/CustomTable';
import { Button, IconButton, TableCell, TableRow, Tooltip } from '@mui/material';
import StatusComp from '../components/common/StatusComp';
import { CheckOutlined, CloseOutlined, DeleteOutlineOutlined, ModeEditOutlineOutlined } from '@mui/icons-material';
import ModalContainer from '../components/containers/ModalContainer';
import api from '../config/axios';
import { toast } from 'react-toastify';

const ScanPricing = () => {
    const [pricings, setPricings] = useState([]);
    const [message, setMessage] = useState('');
    const [loader, setLoader] = useState('');

    const [single, setSingle] = useState({});

    const [showAddLabel, setShowAddLabel] = useState(false);

    const onCloseAddLabelModal = () => {
        setShowAddLabel(false);
    };
    const onOpenAddLabelModal = () => setShowAddLabel(true);

    const [showEditLabel, setShowEditLabel] = useState(false);

    const onCloseEditLabelModal = () => {
        setShowEditLabel(false);
    };
    const onOpenEditLabelModal = () => setShowEditLabel(true);

    const [showDeleteLabel, setShowDeleteLabel] = useState(false);

    const onCloseDeleteLabelModal = () => {
        setShowDeleteLabel(false);
    };
    const onOpenDeleteLabelModal = () => setShowDeleteLabel(true);

    const getPricings = async () => {
        await api
            .get('/scantype/read')
            .then((res) => {
                setPricings(res.data.scanTypes);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        getPricings();
    }, []);

    const addPricing = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            type: e.target.type.value,
            price: e.target.price.value,
        };

        await api
            .post('/scantype/create', data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricings();
                onCloseAddLabelModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const updatePricing = async (e) => {
        e.preventDefault();

        setLoader(true);

        const data = {
            type: single.type,
            price: single.price,
        };

        await api
            .post('/scantype/update/' + single._id, data)
            .then((res) => {
                setLoader(false);
                toast.success(res.data.message);
                getPricings();
                onCloseEditLabelModal();
            })
            .catch((err) => {
                setLoader(false);
                toast.error(err.response.data.message);
            });

        setTimeout(() => {
            setMessage('');
        }, 3000);
    };

    const enableDisableScanType = async (id) => {
        await api
            .put('/scantype/enableDisableScanType/' + id, {})
            .then((res) => {
                getPricings();
                toast.success(res.data.message);
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };

    const DeleteScanType = async (id) => {
        await api
            .delete('/scantype/delete/' + id)
            .then((res) => {
                getPricings();
                toast.success(res.data.message);
                onCloseDeleteLabelModal();
            })
            .catch((err) => {
                toast.error(err.response.data.message);
            });
    };
    return (
        <PageContainer
            title="Scan Pricing"
            desc="Set and manage Scan pricing"
            end={
                <Button onClick={onOpenAddLabelModal} variant="contained">
                    Add Scan Type
                </Button>
            }>
            <CustomTable sx={{ mt: 2 }} fields={['#', 'NAME', 'PRICE', 'STATUS', 'ACTION']} dense={false}>
                {pricings.map((pricing, index) => (
                    <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{pricing.type}</TableCell>
                        <TableCell>${pricing.price}</TableCell>
                        <TableCell>
                            <StatusComp status={pricing.status ? 'active' : 'inactive'} />
                        </TableCell>

                        <TableCell>
                            <IconButton
                                onClick={() => {
                                    setSingle(pricing);
                                    onOpenEditLabelModal();
                                }}
                                title="Edit">
                                <ModeEditOutlineOutlined fontSize="small" />
                            </IconButton>
                            {pricing.status ? (
                                <Tooltip title="Disable">
                                    <IconButton onClick={() => enableDisableScanType(pricing._id)}>
                                        <CloseOutlined fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            ) : (
                                <Tooltip title="Enable">
                                    <IconButton onClick={() => enableDisableScanType(pricing._id)}>
                                        <CheckOutlined fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            )}
                            <IconButton
                                onClick={() => {
                                    setSingle(pricing);
                                    onOpenDeleteLabelModal();
                                }}>
                                <DeleteOutlineOutlined fontSize="small" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                ))}
            </CustomTable>
            {/* create modal */}

            <ModalContainer open={showAddLabel} onClose={onCloseAddLabelModal} hideActions title="Add Scan Type">
                {message}
                <form onSubmit={addPricing}>
                    <div className="form-group mb-3">
                        <label>Name(Type)</label>
                        <input type="text" className="form-control form-control-sm" name="type" required />
                    </div>

                    <div className="form-group mb-3">
                        <label>Price</label>
                        <input type="number" className="form-control form-control-sm" name="price" required />
                    </div>

                    <div className="d-flex mt-2 justify-content-between ">
                        <button
                            type="button"
                            className="btn btn-warning btn-sm "
                            onClick={() => onCloseAddLabelModal()}
                            s>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary btn-sm">
                            Add {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* edit modal */}

            <ModalContainer hideActions open={showEditLabel} onClose={onCloseEditLabelModal} title="Edit Scan Type">
                {message}
                <form onSubmit={updatePricing}>
                    <div className="form-group mb-3">
                        <label>Name</label>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            name="name"
                            required
                            value={single.type}
                            onChange={(e) => setSingle({ ...single, type: e.target.value })}
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label>Price</label>
                        <input
                            type="number"
                            className="form-control form-control-sm"
                            name="maxWeight"
                            required
                            value={single.price}
                            onChange={(e) => setSingle({ ...single, price: e.target.value })}
                        />
                    </div>

                    <div className="d-flex mt-2 justify-content-between ">
                        <button
                            type="button"
                            className="btn btn-warning btn-sm "
                            onClick={() => onCloseEditLabelModal()}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary btn-sm">
                            Update {loader}
                        </button>
                    </div>
                </form>
            </ModalContainer>

            {/* delete label */}
            <ModalContainer
                hideActions
                open={showDeleteLabel}
                onClose={onCloseDeleteLabelModal}
                title="Delete Scan Type">
                {message}
                <div className="text-center mt-0">
                    <p>Are you sure want to delete this Scan Type?</p>
                </div>

                <div className="d-flex justify-content-between ">
                    <button type="button" className="btn btn-default" onClick={() => onCloseDeleteLabelModal()}>
                        Close
                    </button>
                    <button className="btn btn-danger" onClick={() => DeleteScanType(single._id)}>
                        Delete {loader}
                    </button>
                </div>
            </ModalContainer>
        </PageContainer>
    );
};

export default ScanPricing;
